module.exports = __webpack_public_path__ + "static/media/familysmall.b415426d.jpg";